export default __webpack_public_path__ + "static/media/attach.23b3383a.svg";